export const fetchServices = async () => {
    
    return new Promise((resolve) =>
      setTimeout(() => resolve({ data: [{ id: 1, name: 'Ride', description: 'Book a ride' }, { id: 2, name: 'Delivery', description: 'Deliver a package' }] }), 1000)
    );
  };
  